module.exports = __webpack_public_path__ + "img/event_disconnect_user_console.28be1fc9.svg";